import React, { useEffect } from "react";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import { Helmet } from "react-helmet";
import Banner from "../assets/images/privacy-policy/Banner.webp";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title> Privacy Policy | Huntsville Islamic Center</title>
        <script src="https://widget-cdn.simplepractice.com/assets/integration-1.0.js"></script>
      </Helmet>
      <section id="website-responsive" className="px-0">
        <section
          className="container-fluid bg-common-banner"
          style={{ backgroundImage: `url(${Banner})` }}
        >
          <Header />
          <div className="fs-banner-title text-white fw-500 text-center py-5">
            <div className="py-md-5 mb-md-5">Privacy Policy</div>
          </div>
        </section>
        <div className="py-4 py-md-5" />

        <section className="container-fluid">
          <div className="row justify-content-evenly">
            <div className="col-11 col-md-10 mx-auto">
              <div className="pb-4">
                <div className="text-dark fs-ss-18 fw-400">
                  At Huntsville Islamic Center (HIC), we are committed to
                  protecting your privacy. This Privacy Policy outlines how we
                  collect, use, and safeguard your personal information across
                  our website and SMS communications. Please read the entire
                  policy to understand how your data is handled.
                </div>
              </div>

              <div className="pb-4">
                <div className="pb-2 text-dark fs-ss-24 lh-sm fw-600">
                  1. Our Commitment to Privacy
                </div>
                <div className="text-dark fs-ss-18 fw-400">
                  HIC values the privacy of its visitors and members. We are
                  dedicated to safeguarding personal data while delivering
                  spiritual, educational, and community services.
                </div>
              </div>

              <div className="pb-4">
                <div className="pb-2 text-dark fs-ss-24 lh-sm fw-600">
                  2. Information We Collect
                </div>
                <div className="text-dark fs-ss-18 fw-400">
                  We may collect the following types of information:
                  <ul className="mt-2">
                    <li>
                      Non-personal information: Browser type, IP addresses, and
                      cookies used for technical and analytical purposes.
                    </li>
                    <li>
                      Personal information (Website): Data provided through
                      forms, service signups, or general inquiries.
                    </li>
                    <li>
                      Personal information (SMS): As detailed in Section 6
                      below.
                    </li>
                  </ul>
                </div>
              </div>

              <div className="pb-4">
                <div className="pb-2 text-dark fs-ss-24 lh-sm fw-600">
                  3. How We Use Your Information
                </div>
                <div className="text-dark fs-ss-18 fw-400">
                  We use collected data to:
                  <ul className="mt-2">
                    <li>Improve website functionality and user experience</li>
                    <li>Facilitate service enrollment and support</li>
                    <li>Respond to inquiries and provide updates</li>
                    <li>
                      Send important notifications (as detailed in the SMS
                      section)
                    </li>
                    <li>Ensure website and data security</li>
                    <li>Fulfill legal and operational requirements</li>
                  </ul>
                </div>
              </div>

              <div className="pb-4">
                <div className="pb-2 text-dark fs-ss-24 lh-sm fw-600">
                  4. Cookies and Tracking
                </div>
                <div className="text-dark fs-ss-18 fw-400">
                  We use cookies to enhance user experience and analyze traffic.
                  These do not include personally identifiable information
                  unless explicitly provided with consent.
                </div>
              </div>

              <div className="pb-4">
                <div className="pb-2 text-dark fs-ss-24 lh-sm fw-600">
                  5. Data Sharing Practices
                </div>
                <div className="text-dark fs-ss-18 fw-400">
                  We do not share personal information with third parties or
                  affiliates for marketing purposes. Limited data may be shared
                  only with trusted vendors assisting us in providing services,
                  such as website management or SMS delivery.
                </div>
              </div>

              <div className="pb-4">
                <div className="pb-2 text-dark fs-ss-24 lh-sm fw-600">
                  6. Privacy Policy for SMS Communications
                </div>
                <div className="text-dark fs-ss-18 fw-400">
                  <div className="mb-3">
                    At Huntsville Islamic Center (HIC), we are committed to
                    protecting your privacy. This Privacy Policy explains how we
                    collect, use, and share your personal information when you
                    sign up to receive SMS (text) messages from us.
                  </div>

                  <div className="mb-3">
                    <strong>Information We Collect</strong>
                    <p>We may collect:</p>
                    <ul>
                      <li>Your name</li>
                      <li>Your phone number</li>
                      <li>Communication preferences</li>
                      <li>Any responses or messages you send via SMS</li>
                    </ul>
                  </div>

                  <div className="mb-3">
                    <strong>How We Use Your Information</strong>
                    <p>We use your information to:</p>
                    <ul>
                      <li>
                        Send prayer time notifications and community
                        announcements
                      </li>
                      <li>Provide customer support</li>
                      <li>Send school or program updates</li>
                      <li>Notify you of events or schedule changes</li>
                      <li>Respond to your inquiries</li>
                    </ul>
                  </div>

                  <div className="mb-3">
                    <strong>Who We Share Your Information With</strong>
                    <p>
                      We do not share your SMS consent or phone number with any
                      third parties or affiliates for marketing purposes. We may
                      only share limited data with trusted service providers who
                      help us manage our communication systems, solely for the
                      purpose of delivering messages you've opted in to receive.
                    </p>
                    <p>
                      SMS consent is not shared with third parties or affiliates
                      for marketing purposes.
                    </p>
                  </div>

                  <div className="mb-3">
                    <strong>Your Rights</strong>
                    <p>
                      You can opt out at any time by replying STOP to any
                      message. You can also request more information by replying
                      HELP.
                    </p>
                  </div>

                  <div className="mb-3">
                    <strong>Data Security</strong>
                    <p>
                      We take reasonable steps to protect your personal data and
                      prevent unauthorized access, disclosure, or misuse.
                    </p>
                  </div>
                </div>
              </div>

              <div className="pb-4">
                <div className="pb-2 text-dark fs-ss-24 lh-sm fw-600">
                  7. Third-Party Links
                </div>
                <div className="text-dark fs-ss-18 fw-400">
                  Our website may contain links to external sites. While we
                  strive to link only to reputable sources, we are not
                  responsible for the privacy practices of other websites. We
                  recommend reviewing their privacy policies separately.
                </div>
              </div>

              <div className="pb-4">
                <div className="pb-2 text-dark fs-ss-24 lh-sm fw-600">
                  8. Your Rights
                </div>
                <div className="text-dark fs-ss-18 fw-400">
                  You may:
                  <ul className="mt-2">
                    <li>Request access to your personal data</li>
                    <li>Ask for corrections or deletions</li>
                    <li>Withdraw consent (e.g., opt-out of SMS)</li>
                    <li>
                      Contact us via the Contact Information Page to exercise
                      your rights
                    </li>
                  </ul>
                </div>
              </div>

              <div className="pb-4">
                <div className="pb-2 text-dark fs-ss-24 lh-sm fw-600">
                  9. Policy Updates
                </div>
                <div className="text-dark fs-ss-18 fw-400">
                  We may revise this policy to reflect updates in our practices. Any changes will be communicated via our website.
                </div>
              </div>

              <div className="pb-4">
                <div className="pb-2 text-dark fs-ss-24 lh-sm fw-600">
                  10. Contact Information
                </div>
                <div className="text-dark fs-ss-18 fw-400">
                  If you have questions or concerns about this policy, please reach out to us via the contact information page.
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="py-4 py-md-5" />

        <Footer />
      </section>
    </>
  );
};

export default PrivacyPolicy;
